<template>
  <svg
    class="custom-icon"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.91657 9.49977C9.1375 9.49977 8.49981 8.86209 8.49981 8.08302V1H1.41676C0.637687 1 0 1.63768 0 2.41675V16.5835C0 17.3623 0.637687 18 1.41676 18H15.5832C16.3623 18 17 17.3623 17 16.5832V9.50023L9.91657 9.49977Z"
    />
    <path d="M15 0H13V3H10V5H13V8H15V5H18V3H15V0Z" />
  </svg>
</template>
